import React from 'react';

const TopHeaderSection = () => {
    return (
        <div className='h-[80px] max-lg:h-[60x] bg-primary'></div>
    )
}

export default TopHeaderSection;